import TreeList, {
  LoadPanel,
  Column,
  Lookup,
} from "devextreme-react/tree-list";
import useGetDeliveryLocations from "../../../../Hooks/useGET/useGetDeliveryLocations";
import { urgencyKey } from "../../../../Components/OrderComponents/constants";
import { Tooltip } from "devextreme-react";
export default function ItemsTab(vendors) {
  console.log(vendors);

  const { deliveryLocations } = useGetDeliveryLocations();

  return (
    <>
      <TreeList
        id={`treeListItems${vendors[0].id}`}
        dataSource={vendors}
        maxHeight="300px"
        showRowLines={true}
        showBorders={true}
        itemsExpr="items"
        dataStructure="tree"
        onRowPrepared={onRowPrepared}
        elementAttr={{ class: "vendor-tree" }}
      >
        <LoadPanel enabled={true} />
        <Column
          width="auto"
          dataField="name"
          caption="Vendor"
          cellRender={vendorRender}
        />
        <Column width="auto" dataField="itemNumber" cellRender={cellRender} />
        <Column width="auto" dataField="itemName" caption="Item" />
        <Column
          width="auto"
          dataField="deliveryLocationId"
          caption="Delivery Location"
        >
          <Lookup
            dataSource={deliveryLocations}
            valueExpr="id"
            displayExpr="location"
          />
        </Column>
        <Column width="auto" dataField="pricePerItem" />
        <Column width="auto" dataField="quantity" />
        <Column width="auto" dataField="billingCode" />
        <Column width="auto" dataField="project" />
        <Column width="auto" dataField="billingName" />
        <Column width="auto" dataField="notes" />
      </TreeList>
    </>
  );
}
const vendorRender = (e) => {
  if (e.columnIndex === 0 && e.row.level === 0) {
    const vendorName = e.data.name || "";
    const tracking = e?.data?.trackingNumber || "";

    // Strict 20 character truncation logic for tracking number
    const truncatedTracking =
      tracking.length > 25 ? `${tracking.substring(0, 20)}...` : tracking;

    const displayText = `${vendorName}: ${truncatedTracking}`;

    // Create a unique ID using DevExtreme row index and column index
    const targetId = `tracking-target-${e.rowIndex}-${e.columnIndex}`;

    return (
      <>
        <span id={targetId} style={{ cursor: "pointer" }}>
          {displayText}
        </span>

        <Tooltip
          target={`#${targetId}`}
          showEvent="mouseenter"
          hideEvent="mouseleave"
          position="top"
        >
          <div
            style={{
              padding: "8px",
              maxWidth: "250px",
              whiteSpace: "pre-line",
              color: "white",
            }}
          >
            <strong>Full Tracking Info:</strong>
            <br />
            {tracking}
          </div>
        </Tooltip>
      </>
    );
  }
};

const cellRender = (e) => {
  return (
    <a href={e.data.url} target="_blank" rel="noreferrer">
      {e.data.itemNumber}
    </a>
  );
};

const onRowPrepared = (e) => {
  if (e.data) {
    if (e.data.isOutOfStock === true) {
      e.rowElement.style.backgroundColor = "#FF9A9A";
      e.rowElement.style.fontWeight = "bold";
    }
  }
};
